export default __webpack_public_path__ + "static/media/logo_frecciarossa.245fb4cd.svg";